export const defaultPosition = {
  get top() {
    return 0;
  },
  get left() {
    return 0;
  },
  get height() {
    return 0;
  },
  get width() {
    return 0;
  },
  get right() {
    return 0;
  },
  get bottom() {
    return 0;
  },
};
